import React, { Component } from 'react'
import styled from 'styled-components'

export default class TooltipV2 extends Component {
  state = {
    showTooltip: false,
  }

  render() {
    const {
      className,
      children,
      content,
      arrowLocation,
      style,
      contentStyle,
      dialogStyle,
    } = this.props

    return (
      <Container className={className} style={style}>
        <Toggle
          onMouseOver={() => this.setState({ showTooltip: true })}
          onMouseOut={() => this.setState({ showTooltip: false })}>
          {children}
        </Toggle>
        <Dialog
          show={this.state.showTooltip}
          arrowLocation={arrowLocation}
          style={dialogStyle}>
          <Content style={contentStyle}>{content}</Content>
        </Dialog>
      </Container>
    )
  }
}

const Container = styled.div`
  position: relative;
  width: fit-content;
`

const Toggle = styled.div`
  cursor: pointer;
`

const Dialog = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #1d1e22;
  position: absolute;
  box-sizing: border-box;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  z-index: 10;

  &::before {
    content: '';
    position: absolute;
    width: 10px;
    aspect-ratio: 1;
    border-radius: 2px;
    background-color: #1d1e22;

    ${({ arrowLocation }) =>
      arrowLocation === 'topLeft' &&
      `
      top: -4px;
      left: 5px;
      transform: rotate(45deg);
    `}
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`



// WEBPACK FOOTER //
// ./src/components/TooltipV2/index.js